module.exports = __webpack_public_path__ + "static/media/default-car-preview@2x.cd376fcd.png";